import qs from "qs-lite";
import { useMutation, useQuery, useQueryClient } from "react-query";
import api from "../../utils/api";
import { useHubSnackBar } from "../useSnackBar";
import { invalidate } from "../../helpers/clientHelper";

const VENDORS = "/vendors";
const CACHE_TIME = 30_600_000;

const getAllVendorData = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1]);
  return api.get(`${VENDORS}?${queryString}`);
};

export const useGetAllVendorData = ({ defaultLocation = 1 }) => {
  const query = new URLSearchParams(window.location.search);

  const location = query.get("location") || defaultLocation;

  const orderBy = query.get("orderBy") || "name";
  const sortOrder = query.get("sortOrder") || "asc";
  const limit = query.get("limit") || 100;
  const offset = query.get("offset") || 0;

  const queryProps = {
    limit,
    offset,
    orderBy,
    sortOrder,
    ...(!location || location === "All" ? {} : { location }),
  };

  return useQuery([VENDORS, queryProps], getAllVendorData, {
    retry: false,
  });
};

const getVendorList = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1]);
  return api.get(`${VENDORS}/list?${queryString}`);
};
export const useGetVendorList = ({ location = null, enabled = true }) => {
  return useQuery([VENDORS, { location }], getVendorList, {
    enabled,
    staleTime: CACHE_TIME,
    cacheTime: CACHE_TIME,
  });
};

const postCreateVendor = (payload) => api.post(VENDORS, payload);
export const usePostCreateVendor = () => {
  const { addSnackbarSuccess } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(postCreateVendor, {
    onSuccess: () => {
      invalidate(queryClient, VENDORS);
      addSnackbarSuccess({ message: "Successfully Created Vendor" });
    },
  });
};
